import React from 'react';
import AppHeader from '../../components/Header/Header';
import Organigrama_ispa from '../../assets/Organigrama_ispa.jpg';
import AppLayout from '../../components/layout';
import SidebarMenu from '../../components/SidebarMenu'; 
import SectionHeading from '../../components/SectionHeading';
import BannerSection from '../../components/BannerSection';
import BreadcrumbNav from '../../components/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Instituição' },
    { label: 'Organigrama' }
];

function Organigrama() {
    return (
        <div>
            <header id='header'>
                <AppHeader />
            </header>
            <BannerSection
                title="Estrutura Organizacional"
                subtitle="Organigrama do Instituto Superior Politécnico Atlântida"
                description={`O organigrama do Instituto Superior Politécnico Atlântida reflete a estrutura organizacional que apoia nossa missão de excelência acadêmica e inovação.`}
                backgroundImage={require('../../assets/BannerANU_ispa.jpg')}
                backgroundId="instituition-Banner"      
            />
            <BreadcrumbNav items={caminho} />
            <br />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
                <br />
                <div className="row flex-row-reverse">
                    <div className="col-12 col-md-4 col-lg-3 col-xl-2">
                        <SidebarMenu
                            title="Instituição"
                            items={[
                            { label: "Apresentação", href: "/instituicao" },
                            { label: "Palavras do Presidente", href: "/instituicao/palavra-do-presidente" },
                            { label: "Organigrama", href: "/instituicao/organigrama" },
                            { label: "Legalidade", href: "/instituicao/legalidade" },
                            { label: "Missão, Visão e Valores", href: "/instituicao/missao-visao-valores" },
                            { label: "Apoio Social", href: "/instituicao/apoio-social" },
                            { label: "Perguntas Frequentes", href: "/instituicao/perguntas-frequentes" },
                            { label: "Decretos", href: "/instituicao/decretos" },
                            { label: "Regulamento", href: "/instituicao/regulamentos" },
                            ]}
                        />
                        </div>
                    <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                        <br />
                        <div className="details-magazine">
                            <p className="f-reg">
                                <SectionHeading title="Organigrama" />
                                <br />
                                O organigrama da Instituição foi concebido obedecendo as diretrizes do Decreto Presidencial n.º 310/20 de 7 de Dezembro, 
                                que estabelece o Regime Jurídico do Subsistema de Ensino Superior, assim como o das políticas Institucionais:    
                            </p>
                            <br />
                            <img src={Organigrama_ispa} alt="Organigrama" className="img-fluid rounded shadow" />
                        </div>
                        <br /><br />
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
            </main>
            <AppLayout />
        </div>
    );
}

export default Organigrama;
